import { z } from 'zod';
import { uuidSchema } from '../const/uuidSchema';

export const SIZE_CHART_DOMAIN_VALUES = ['CLOTHES', 'SHOES', 'BRA', 'UNDERWEAR', 'ACCESSORIES', 'OTHER'] as const;
export const SIZE_CHART_GENDER_VALUES = ['WOMEN', 'MEN', 'UNISEX', 'KIDS'] as const;

const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const sizeChartRowInputSchema = z.object({
    id: uuidSchema.optional(),
    key: z
        .string({ required_error: 'укажите название размера', invalid_type_error: 'название должно быть строкой' })
        .trim()
        .min(1, 'введите название размера')
        .max(50, 'не больше 50 символов'),
    order: z.number().int().min(0).max(10_000),
});

export type SizeChartRowInputSchema = z.infer<typeof sizeChartRowInputSchema>;

export const sizeChartInputSchema = z.object({
    id: uuidSchema.optional(),

    name: z
        .string({ required_error: 'укажите название сетки', invalid_type_error: 'название должно быть строкой' })
        .trim()
        .min(1, 'введите название')
        .max(300, 'не больше 300 символов'),

    slug: z
        .string({ required_error: 'укажите slug', invalid_type_error: 'slug должен быть строкой' })
        .trim()
        .min(1, 'введите slug')
        .max(100, 'не больше 100 символов')
        .regex(SLUG_REGEX, 'только строчные латинские буквы, цифры и дефисы (без -- и без дефиса в начале/конце)'),

    domain: z.enum(SIZE_CHART_DOMAIN_VALUES, {
        required_error: 'выберите тип сетки',
        invalid_type_error: 'некорректный тип',
    }),

    gender: z.enum(SIZE_CHART_GENDER_VALUES).nullable().optional(),

    rows: z
        .array(sizeChartRowInputSchema)
        .min(1, 'добавьте хотя бы один размер')
        .max(200, 'слишком много размеров (максимум 200)')
        .superRefine((rows, ctx) => {
            const seen = new Set<string>();
            rows.forEach((r, idx) => {
                const k = r.key.trim().toLowerCase();
                if (seen.has(k)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: 'размеры должны быть уникальны',
                        path: [idx, 'key'],
                    });
                }
                seen.add(k);
            });
        }),
});

export type SizeChartInputSchema = z.infer<typeof sizeChartInputSchema>;
